module.exports = __webpack_public_path__ + "static/media/FuturaPTBook.99541f31.otf";